import React from 'react'
import PropTypes from 'prop-types'
import { InfusionsoftIntegration } from '.'
import Title from 'shared/components/Title'
import { compose } from 'redux'
import * as R from 'ramda'

import { connectApi } from 'libs/connectApi'
import toast from 'libs/toast'
import { IntegrationContainer } from 'components/IntegrationContainer'

class Container extends React.Component {
  static propTypes = {
    credential: PropTypes.object,
    authenticateInfusionsoft: PropTypes.object,
    revokeAccess: PropTypes.object,
    toggleCustomersSync: PropTypes.object,
  }

  createOnSubmit = (callback) => (credential) => {
    this.props.authenticateInfusionsoft
      .callApi({
        data: credential,
        update(store, credential) {
          store.write('infusionsoft/authentication/', credential)
        },
      })
      .then(() => {
        callback()
        toast.success('Woohoo! Simplesat is now connected with Infusionsoft.')
      })
      .catch(() => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
      })
  }

  revokeAccess = () => {
    this.props.revokeAccess
      .callApi({
        update(store) {
          store.write('infusionsoft/authentication/', null)
        },
      })
      .then(() => {
        toast.success('Successfully revoked access with Infusionsoft.')
      })
      .catch(() => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
      })
  }

  toggleCustomersSync = () => {
    this.props.toggleCustomersSync
      .callApi({
        data: {
          enable: !this.props.credential.data.is_enable_customer_sync,
        },
        update: (store, data) => {
          if (data.sync_successful) {
            store.write('infusionsoft/authentication/', (credential) => {
              return R.assoc(
                'is_enable_customer_sync',
                !credential.is_enable_customer_sync
              )(credential)
            })
          } else {
            throw Error('sync unsuccessful')
          }
        },
      })
      .then(() => {
        if (this.props.credential.data.is_enable_customer_sync) {
          toast.success('Customer sync enabled!')
        } else {
          toast.success('Customer sync deactivated.')
        }
      })
      .catch(() => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
      })
  }

  render() {
    return (
      <React.Fragment>
        <IntegrationContainer>
          <Title title="Infusionsoft Contact Sync" />
          <InfusionsoftIntegration
            syncButtonLoading={
              (!this.props.credential.data && this.props.credential.loading) ||
              this.props.toggleCustomersSync.loading ||
              this.props.authenticateInfusionsoft.loading ||
              this.props.revokeAccess.loading
            }
            authenticationLoading={
              (!this.props.credential.data && this.props.credential.loading) ||
              this.props.authenticateInfusionsoft.loading ||
              this.props.revokeAccess.loading
            }
            isCustomersSyncEnabled={R.prop('is_enable_customer_sync')(this.props.credential.data)}
            isAuthenticated={!!this.props.credential.data}
            isCredentialError={!!this.props.authenticateInfusionsoft.error}
            createOnSubmit={this.createOnSubmit}
            revokeAccess={this.revokeAccess}
            toggleCustomersSync={this.toggleCustomersSync}
          />
        </IntegrationContainer>
      </React.Fragment>
    )
  }
}

export const InfusionsoftIntegrationContainer = compose(
  connectApi({
    name: 'credential',
    url: 'infusionsoft/authentication/',
    schema: '@infusionsoftCredential',
    delay: 500,
  }),
  connectApi({
    name: 'authenticateInfusionsoft',
    url: 'infusionsoft/authentication/',
    method: 'post',
    skip: true,
    schema: '@infusionsoftCredential',
  }),
  connectApi({
    name: 'revokeAccess',
    method: 'delete',
    url: 'infusionsoft/authentication/',
    skip: true,
    delay: 500,
  }),
  connectApi({
    name: 'toggleCustomersSync',
    method: 'patch',
    url: 'infusionsoft/trigger-sync-customer/',
    skip: true,
    delay: 500,
  })
)(Container)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/InfusionsoftIntegration/container.js